import CodebookValueNotFoundError from '../../CodebookValueNotFoundError'
import { TranslatableNameCodebook } from '../../TranslatableNameCodebook'
import { $t } from '../../../composables/i18n'

export enum ObjectKindTypeId {
  ACCOMMODATION = 1,
  OTHER_DAYS = 2,
  WELLNESS_FACILITY = 3,
  CONFERENCE = 4,
  GASTRONOMY = 5,
  OTHER_MINUTES = 6,
  SPORTS_FIELDS = 7,
}

export class ObjectKindType extends TranslatableNameCodebook {
  static readonly ACCOMMODATION = new ObjectKindType(
    ObjectKindTypeId.ACCOMMODATION,
    $t('Accommodation'),
    'bed',
    true,
    false,
  )
  static readonly OTHER_DAYS = new ObjectKindType(
    ObjectKindTypeId.OTHER_DAYS,
    $t('Other - days'),
    'calendar-days',
    false,
    false,
  )
  static readonly WELLNESS_FACILITY = new ObjectKindType(
    ObjectKindTypeId.WELLNESS_FACILITY,
    $t('Wellness facility'),
    'heart-pulse',
    false,
    true,
  )
  static readonly CONFERENCE = new ObjectKindType(
    ObjectKindTypeId.CONFERENCE,
    $t('Conference'),
    'comments',
    false,
    true,
  )
  static readonly GASTRONOMY = new ObjectKindType(
    ObjectKindTypeId.GASTRONOMY,
    $t('Gastronomy'),
    'utensils',
    false,
    true,
  )
  static readonly OTHER_MINUTES = new ObjectKindType(
    ObjectKindTypeId.OTHER_MINUTES,
    $t('Other - minutes'),
    'clock',
    false,
    true,
  )
  static readonly SPORTS_FIELDS = new ObjectKindType(
    ObjectKindTypeId.SPORTS_FIELDS,
    $t('Sports fields'),
    'futbol',
    false,
    true,
  )

  private constructor(
    public readonly id: ObjectKindTypeId,
    name: string,
    public readonly icon: string,
    public readonly hasCapacity: boolean,
    public readonly isHourlyBased: boolean,
  ) {
    super(name)
  }

  static getById = (id: ObjectKindTypeId): ObjectKindType => {
    const value = this.all().find((item: ObjectKindType) => item.id === id)

    if (!value) {
      throw new CodebookValueNotFoundError(ObjectKindType.name, id)
    }

    return value
  }

  static all = (): ObjectKindType[] => {
    return [
      ObjectKindType.ACCOMMODATION,
      ObjectKindType.OTHER_DAYS,
      ObjectKindType.WELLNESS_FACILITY,
      ObjectKindType.CONFERENCE,
      ObjectKindType.GASTRONOMY,
      ObjectKindType.OTHER_MINUTES,
      ObjectKindType.SPORTS_FIELDS,
    ]
  }
}
